<template>
  <div id="aid-point">
    <h6>{{rank}} 点位{{p.id}}</h6>
    <a-descriptions :column="5">
      <a-descriptions-item label="位置">{{p.location}}</a-descriptions-item>
      <a-descriptions-item label="材质">{{p.material}}</a-descriptions-item>
      <a-descriptions-item label="数量">{{p.count}}</a-descriptions-item>
      <a-descriptions-item label="可见尺寸">{{p.size}} mm</a-descriptions-item>
      <a-descriptions-item label="测量时间">{{p.created_at}}</a-descriptions-item>
    </a-descriptions>
    <div class="img-box">
      <img v-for="(img,idx) in p.images" :key="idx" :src="img" @click="toShow(img)" />
    </div>
    <ImageList v-if="show" :visible.sync="show" :imgs="p.images" :current="cur" />
  </div>
</template>
<script>
import ImageList from "@/components/ImageList";
export default {
  components: { ImageList },
  props: { p: Object, rank: [Number, String] },
  data() {
    return {
      show: false,
      cur: this.p.images[0]
    };
  },
  methods: {
    toShow(img) {
      this.cur = img;
      this.show = true;
    }
  }
};
</script>
<style lang="scss" scoped>
#aid-point {
  margin-top: 10px;
  // border: 1px dashed red;
  padding-bottom: 24px;
  border-bottom: 1px solid #dcdcdc;
  .img-box {
    img {
      width: 80px;
      height: 80px;
      margin-right: 20px;
      border-radius: 4px;
      object-fit: cover;
      cursor: pointer;
      border: 1px dashed transparent;
    }
    img:hover {
      border-color: red;
    }
  }
}
</style>